import { AccrualProfile, AccrualProfileCreate, AccrualProfileUpdate } from "./@types/AccrualProfile";
export class AccrualProfileRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/accrual_profiles';
    }
    async getAll(filters?: Record<string, any>): Promise<AccrualProfile[]>{
        const response = await this.httpService.get<TKResponse<AccrualProfile[]>>(this.baseUrl, filters);
        return response.data.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    }
    async getOne(id: number, filters?: Record<string, any>): Promise<AccrualProfile> {
        const response = await this.httpService.get<TKResponse<AccrualProfile>>(`${this.baseUrl}/${id}`, filters);
        return response.data;
    }
    async create(data: AccrualProfileCreate): Promise<AccrualProfile> {
        const response = await this.httpService.post<TKResponse<AccrualProfile>, AccrualProfileCreate>(this.baseUrl, { data });
        return response.data;
    }
    async update(id: number, data: AccrualProfileUpdate): Promise<AccrualProfile> {
        const response = await this.httpService.patch<TKResponse<AccrualProfile>, AccrualProfileUpdate>(`${this.baseUrl}/${id}`, { data });
        return response.data;
    }
    async delete(id: number): Promise<void> {
        return await this.httpService.delete(`${this.baseUrl}/${id}`);
    }
}

